import TableTemplate from "../../TableTemplate/tableTemplate";
import {
  IAddEditRoleFormValues,
  IRolesTableReport,
  IRolesTableSearchParam,
} from "../../../Interfaces/roleAndPermissionsInterfaces";
import { getRolesTable } from "../../../Requests/roleAndPermissionsRequests";
import { createContext, useEffect, useState } from "react";
import SearchParamUI from "./SearchParamUI";
import TableUI from "./TableUI";
import { useDebouncer } from "../../../Hooks/useDebouncer";

export const RolesTableContext = createContext({
  onEdit: (value: IAddEditRoleFormValues) => {},
  refreshTableFlag: false,
  setRefreshTableFlag: (flag: boolean) => {},
});

interface IProps {
  onEdit: (formValues: IAddEditRoleFormValues) => void;
  refreshTableFlag: boolean;
  setRefreshTableFlag: (flag: boolean) => void;
}

const Table = ({
  onEdit,
  refreshTableFlag,
  setRefreshTableFlag,
}: IProps) => {
  const [searchParameters, setSearchParameters] =
    useState<IRolesTableSearchParam>({} as IRolesTableSearchParam);
  const [nameInput, setNameInput] = useState("");
  const debouncedName = useDebouncer(nameInput, 300);

  useEffect(() => {
    setSearchParameters((current) => ({
      ...current,
      name: debouncedName,
    }));
  }, [debouncedName]);

  const changeSearchParameter = (name: string, value: any) => {
    setSearchParameters((current) => ({ ...current, [name]: value }));
  };

  return (
    <div
      dir="rtl"
      className="mx-auto flex w-fit flex-col items-start justify-start gap-3"
    >
      <SearchParamUI
        nameInput={nameInput}
        onNameChange={setNameInput}
        onChange={changeSearchParameter}
        searchParameters={searchParameters}
      />

      <TableTemplate<IRolesTableSearchParam, IRolesTableReport>
        getDataTable={getRolesTable}
        TableUI={({ reports, onAction }) => (
          <RolesTableContext.Provider
            value={{ onEdit, refreshTableFlag, setRefreshTableFlag }}
          >
            <TableUI reports={reports} onAction={onAction} />
          </RolesTableContext.Provider>
        )}
        searchParameters={searchParameters}
        tableWrapperClassname="!mx-0"
      />
    </div>
  );
};

export default Table;
